<template>
    <div>
      支付
    </div>
  </template>

<script>
export default {

};
</script>

  <style>

  </style>
